import { FC, useState } from 'react'
import { Label } from './label'
import { Input } from './input'
import { ModalForm } from '../notifications/modal/ModalForm'

interface Props {
  initialValue?: string
  inputLabel: string
  onCancel: () => void
  onSave: (name: string) => void
  isSaving: boolean
  saveButtonText?: string
}

export const ResourceNameForm: FC<Props> = ({
  initialValue = '',
  inputLabel,
  onCancel,
  onSave,
  isSaving,
  saveButtonText,
}) => {
  const [name, setName] = useState(initialValue)

  return (
    <ModalForm
      fields={
        <div>
          <Label>{inputLabel}</Label>
          <Input
            autoFocus
            value={name}
            onChange={(event) => setName(event.target.value)}
            required
          />
        </div>
      }
      onCancel={onCancel}
      onSave={() => onSave(name)}
      isSaving={isSaving}
      saveButtonText={saveButtonText}
    />
  )
}